import { FC } from "react";
import PageTemplate from "../PageTemplate";
import SavedWorksPage from "./SavedWorksPage";

const SavedWorks: FC = () => {
    return <PageTemplate Page={SavedWorksPage} />;
};

export default SavedWorks;
